import React, { useEffect, useState, useRef } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Modal, ModalBody, Label } from "reactstrap"
// import "./datatables.scss";
// import '../Icons/IconFontawesome';
import { AvField, AvForm, AvRadio, AvRadioGroup } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';
import Utils from '../Utility';
import { post, get, put, del, upload, download } from "../../helpers/api_helper";
import DeleteModal from '../../components/ConfirmModal/DeleteModal';;
import DataTable from 'react-data-table-component';
import Cropper from "react-cropper";
import AddForm from "./Add";
import "cropperjs/dist/cropper.css";
import Resizer from "react-image-file-resizer";
import defaultProfilePic from "../../assets/images/user.png"
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import Loader from "../../components/Loader";

const Table = (props) => {
  const { user, role, currentUser, path } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const [isAddForm, setIsAddForm] = useState(false);
  const [file, setFile] = useState(null);
  const [imageChanged, setImageChanged] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isAdd, setIsAdd] = useState(false);
  const imageInput = useRef();
  const cropper = useRef();

  useEffect(() => {
    if (user?.token)
      getData();
  }, [user]);

  const getData = () => {
    if (!loading) {
      setLoading(true);
      get("/testimonial", { token: user?.token })
        .then(res => {
          setLoading(false);
          if (res?.statusCode == 200) {
            setData(res?.data);
          } else {
            toast.error(res?.error);
          }
        })
        .catch(err => {
          setLoading(false);
          console.log('error while getting enquiries', err);
          toast.error('Something Went Wrong!');
        })
    }
  }

  // useEffect(() => {
  // }, [currentData])

  useEffect(() => {
    setColumns([
      {
        name: "Position",
        cell: (row, index) => <>
          <Draggable key={row._id} draggableId={row._id} index={index}>
            {(provided, snapshot) => (
              <div
                ref={provided.innerRef}
                {...provided.draggableProps}
                {...provided.dragHandleProps}
              >
                <i className="mdi mdi-menu" style={{ fontSize: 20, color: Utils.textColor }}></i>
              </div>
            )}
          </Draggable>
        </>,
        minWidth: '120px'
      },
      {
        name: 'Image',
        cell: (row) => <>
          {/* <img title={'logo'} src={row?.image} style={{ width: 70, height: 'auto' }} /> */}
          <img src={row?.image !== "" ? row.image : defaultProfilePic} style={{ width: 70, height: 70, padding: 10 }} />

        </>,
        minWidth: '150px'
      },
      {
        name: 'Name',
        selector: row => row?.name,
        minWidth: '100px'
      },
      {
        name: 'Designation',
        selector: row => row?.role,
        maxWidth: '150px'
      },
      {
        name: 'Company Name',
        selector: row => row?.title,
        // cell: (row) => <>
        //   <p>{row?.title}</p>
        // </>,
        minWidth: '150px'
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateStatus(row)}
            title={row?.isActive ? "Inactive" : "Active"}
            style={{ backgroundColor: !row.isActive ? 'red' : 'green', marginRight: 9, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none' }}>
            <span className="text-white" style={{}}>
              {!row?.isActive ? 'Inactive' : 'Active'}
            </span>
          </Button>
        </>,
        name: 'Status',
        ignoreRowClick: true,
        maxWidth: '110px',
        minWidth: '90px'
      },
      {
        cell: (row) => <>
          <Button onClick={() => handleUpdateEdit(row)}
            title={"Edit"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-pencil" style={{ fontSize: 20, color: Utils.textColor }}></span></Button>
          <Button onClick={() => handleDelete(row)}
            title={"Delete"}
            style={{ backgroundColor: Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8, border: 'none', height: 44 }}><span className="mdi mdi-delete" style={{ fontSize: 20, color: Utils.textColor }}></span></Button>
        </>,
        name: 'Action',
        ignoreRowClick: true,
        maxWidth: '100px'
      },
    ])
  }, [data]);

  useEffect(() => {
    if (!isAddForm) {
      setCurrentData(null);
    }
  }, [isAddForm])

  const handleUpdateEdit = (proj) => {
    console.log('updating proj', proj);
    setCurrentData(proj);
    setFile(proj?.image);
    setImageChanged(false);
    setIsAddForm(true);
  }

  const handleUpdateStatus = (row) => {
    setCurrentData({ ...row, actionType: "Status" });
    setDeleteModal(true);
  }

  const handleDelete = (row) => {
    setCurrentData({ ...row, actionType: "Delete" });
    setDeleteModal(true);
  }

  const onConfirm = () => {
    if (!loading) {
      setLoading(true);
      let body = {
        testiId: currentData?._id,
        token: user?.token
      }
      if (currentData?.actionType == 'Status') {
        body = { ...body, isActive: !currentData?.isActive }
        put("/testimonial", body)
          .then(res => {
            setLoading(false);
            if (res?.statusCode == 200) {
              setDeleteModal(false);
              toast.success(res?.message);
              getData()
            } else
              toast.error("" + res?.error);
          })
          .catch(err => {
            setLoading(false);
            console.error("error while updating data", err);
            toast.error("Something Went Wrong!");
          })
      }
      if (currentData?.actionType == 'Delete') {
        del("/testimonial", body)
          .then(res => {
            setLoading(false);
            if (res?.statusCode == 200) {
              setDeleteModal(false);
              toast.success(res?.message);
              getData()
            } else
              toast.error("" + res?.error);
          })
          .catch(err => {
            setLoading(false);
            console.error("error while updating data", err);
            toast.error("Something Went Wrong!");
          })
      }
    }
  }

  const onStatus = () => {
    console.log('status', currentData);
    setLoading(true);
    let body = {
      testiId: currentData?._id,
      isActive: !currentData?.isActive,
      token: user?.token
    }
    let url = `/testimonial`;
    put(url, body)
      .then(json => {
        console.log('response from update status', json);

        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          setDeleteModal(false);
          getData();
          setCurrentData(null);
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        toast.error(error);
        console.error('error while deleting user', error);
      })
  }

  const onDelete = () => {
    console.log('deleted', currentData);
    let body = {
      testiId: currentData?._id,
      token: user?.token
    }
    del(`/testimonial`, body)
      .then(json => {
        console.log('response from delete user', json);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setCurrentData(null);
        }
      })
      .catch(error => {
        console.error('error while deleting user', error);
      })
  }

  const ExpandedComponent = ({ data }) =>
    <div className='expending_box'>
      <Row>
        <Col lg={5}>
          <div className='expend_detail'>
            <h5>Testimonial</h5>
          </div>
        </Col>
        <Col lg={6}>
          <div className='expend_detail'>
            <p>{data?.desc && data?.desc?.length > 150
              ? data?.desc.slice(0, 150) + '...'
              : data?.desc}</p>
          </div>
        </Col>
      </Row>
    </div>

  const handleDragEnd = (result) => {
    // console.log('dragging item', result);
    // Handle the drag-and-drop logic here
    if (!result.destination) return; // Item was dropped outside the list
    const items = [...data];
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    let ids = [], position = [];
    items.forEach((item, index) => {
      ids.push(item?._id);
      position.push(index);
    })
    let body = {
      ids,
      position,
      token: user?.token
    }
    put("/testimonial/position", body)
      .then(res => {
        // if (res?.statusCode == 200)
        setData(items);
      })
  };


  return (
    <React.Fragment>
      {!isAddForm ?
        <div className="">
          <Row>
            <DeleteModal
              show={deleteModal}
              // onDeleteClick={onConfirm}
              onDeleteClick={() => currentData?.actionType == 'Status' ? onStatus() : onDelete()}
              onCloseClick={() => setDeleteModal(false)}
              actionType={currentData?.actionType}
              //             onDeleteClick={() => currentModalData?.actionType == 'Status' ? onStatus() : onDelete()}
              data={currentData}
            />
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                    <div>
                      {/* <CardTitle className="h4">{props.role}</CardTitle> */}
                      <CardSubtitle className="mb-3">
                        {/* {role} you have added before, All the will be used for Testimonials. */}
                      </CardSubtitle>
                    </div>
                  </div>

                  <div className="d-flex" style={{ marginLeft: 'auto', marginBottom: 30 }}>
                    <h5>{role}</h5>
                    {!error &&
                      <div className="text-center" style={{ marginLeft: 'auto' }}>
                        <button className="button-class" style={{ backgroundColor: Utils.themeColor, border: 'none', color: Utils.textColor }} onClick={() => setIsAddForm(true)}>
                          <p>Add</p>
                          {/* <span>+</span> */}
                        </button>
                      </div>
                    }
                  </div>
                  <Loader visible={loading} />

                  <DragDropContext onDragEnd={handleDragEnd}>
                    <Droppable droppableId="table">
                      {(provided) => (
                        <div {...provided.droppableProps} ref={provided.innerRef}>
                          <DataTable
                            columns={columns}
                            data={data}
                            pagination
                            expandableRows={true}
                            expandOnRowClicked={false}
                            expandableRowDisabled={row => row.disabled}
                            expandableRowsComponent={ExpandedComponent}
                            expandableRowsComponentProps={row => row.Action}
                            customStyles={{
                              headCells: {
                                style: {
                                  color: 'black',
                                  fontWeight: 'bold',
                                  fontSize: 15,
                                  maxWidth: 80
                                },
                              },
                              cells: {
                                style: {
                                  maxWidth: 50
                                }
                              }
                            }}
                            conditionalRowStyles={[{
                              when: row => row?.seen?.length < 1,
                              style: { backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, color: 'white', cursor: 'pointer' },
                            }]}
                          // onRowClicked={(r, e) => seenNoti(r)}
                          />
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
        :
        <AddForm
          user={user}
          setIsAddForm={setIsAddForm}
          loading={loading}
          setLoading={setLoading}
          onCloseRequest={() => setIsAddForm(false)}
          onRefreshData={() => getData()}
          getData={getData}
          currentData={currentData}
          file={file}
          setFile={setFile}
          setCurrentData={setCurrentData}
        />
        // </div>
      }
    </React.Fragment >
  )
}

export default Table;
